import { render, staticRenderFns } from "./DefaultPopUp.vue?vue&type=template&id=1fe10dc8&scoped=true&"
import script from "./DefaultPopUp.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DefaultPopUp.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./DefaultPopUp.vue?vue&type=style&index=0&id=1fe10dc8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe10dc8",
  null
  
)

export default component.exports